import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i1307457434__a)" }, [
      _createElementVNode("path", {
        fill: "#59AD3B",
        "fill-rule": "evenodd",
        d: "M2 13.592a4.014 4.014 0 0 0 4-3.866V5.592c.413 2.478 4.056 7.085 7.999 8L14 10.531c-.122-1.872-1.184-2.474-2.63-2.984C9.435 6.831 6.4 5.758 6 3.36c1.262 2.09 5.363 3.217 7.623 3.203a5.533 5.533 0 0 0-.592-1.38c-.777-1.269-2.176-2.258-3.699-2.258H6.666c-1.522 0-2.922.989-3.699 2.259C2.28 6.308 2.035 7.75 2 9.592v4Zm6 1.333a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333Z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1307457434__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M14 14.925H2v-12h12z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }